/* @flow strict */

import * as React from 'react';
import SimpleInput from '/client/src/components/forms/simpleInput';
import SimpleSelect from '/client/src/components/forms/select';
import { POST } from '/client/src/api/';
import { emailRegexp } from '/client/src/constants';

type PropsType = {
  handleAddCb: ({}) => void,
  eventId: string | number,
  pendingComtroll: (boolean) => void
};

const CollaboratorPageTopSection = (props: PropsType): React.Element<'div'> => {
  const randomIndex = _.random(1, Date.now());
  const [emailAddress, setEmail] = React.useState('');
  const [permission, setPermissions] = React.useState('Write');
  const [isEmailValid, setIsEmailValid] = React.useState(true)

  const invite = async () => {
    try {
      props.pendingComtroll(true);

      const { result } = await POST(`/api/v1/1/events/${props.eventId}/collaborators`, {
        email_address: emailAddress,
        permission,
        app: true
      });

      props.handleAddCb(result, permission);
      props.pendingComtroll(false);
    } catch (e) {
      console.log(e);
      console.error('Can\'t invite collaborator');

      props.pendingComtroll(false);
    }
  };

  return (
    <div className="panel panel-default panel-page panel-collaborators">
      <div className="panel-heading panel-heading-color2">
        <div className="panel-title">
          <span>Collaborate</span>
        </div>
      </div>

      <div className="panel-body">
        <div className="container-fluid">
          <h3>Are you working on this event with anyone?</h3>
          <p>Together everyone achieves more. Add a collaborator so they can help manage the event with you.</p>
          <div className="collaborators">
            <div className="form-group">
              <label>
                <b>Invite someone to collaborate.</b>
              </label>

              <div className="row">
                <div className="col-sm-5">
                  <SimpleInput
                    name={`CollaboratorPageTopSection-${randomIndex}`}
                    id={`CollaboratorPageTopSection-${randomIndex}`}
                    type='email'
                    withAddon={<i className='icon icon-envelope2' />}
                    addonPosition='start'
                    placeholder='Collaborator Email'
                    onChange={(e) => {
                      setEmail(e.target.value);

                      const isValid = emailRegexp.test(e.target.value);
                      setIsEmailValid(isValid || !e.target.value);
                    }}
                    value={emailAddress}
                    validator={!isEmailValid ? {
                      text: 'Please enter a proper email address.'
                    } : false}
                    forceShowValidator={!isEmailValid}
                  />
                </div>

                <div className="col-sm-4">
                  <SimpleSelect
                    value={permission}
                    callBack={(e) => {
                      setPermissions(e.target.value);
                    }}
                    items={[
                      {
                        label: 'Can edit and view your event',
                        value: 'Write'
                      },
                      {
                        label: 'Can view your event',
                        value: 'Read'
                      }
                    ]}
                  />
                </div>

                <div className="col-sm-3">
                  <button
                    style={{ padding: '4px 30px' }}
                    className="btn btn-pink btn-sm"
                    onClick={invite}
                  >
                    Invite to collaborate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollaboratorPageTopSection;
